export interface IAppConfig {
  authorityUrl: string;
  clientId: string;
  audience: string;
  secret: string;
  scope: string;
  redirectUri: string;
  logoutUri: string;
  sogEngageUrl: string;
  communityUrl: string;
  communityApiUrl: string;
  resourcesApiUrl: string;
  enableChatRouteOnly: boolean;
}

export class AppConfig implements IAppConfig {
  constructor(){
    this.authorityUrl = "";
    this.clientId = "";
    this.audience = "";
    this.secret = "";
    this.scope = "";
    this.redirectUri = "";
    this.logoutUri = "";
    this.sogEngageUrl = "";
    this.communityUrl = "";
    this.communityApiUrl = "";
    this.resourcesApiUrl = "";
  }

  authorityUrl: string;
  clientId: string;
  audience: string;
  secret: string;
  scope: string;
  redirectUri: string;
  logoutUri: string;
  communityUrl: string;
  communityApiUrl: string;
  sogEngageUrl: string;
  resourcesApiUrl: string;
  enableChatRouteOnly: boolean;
}
